import register from '../../../../global/js/registry';
export default register('m-search-flyout', () => import(/* webpackMode: "lazy" */ './m-search-flyout.controller'));
